import { render, staticRenderFns } from "./CountrySettingView.vue?vue&type=template&id=21a1dff3"
import script from "./CountrySettingView.vue?vue&type=script&lang=js"
export * from "./CountrySettingView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21a1dff3')) {
      api.createRecord('21a1dff3', component.options)
    } else {
      api.reload('21a1dff3', component.options)
    }
    module.hot.accept("./CountrySettingView.vue?vue&type=template&id=21a1dff3", function () {
      api.rerender('21a1dff3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/superadmin/countrysetting/CountrySettingView.vue"
export default component.exports